import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import {
  Dialog,
  DialogActions,
  Divider,
  Grid,
  IconButton
} from '@material-ui/core';
import React from 'react';
import { RfqCommonDialogStyles } from './styles';
import CloseIcon from '@material-ui/icons/Close';

interface Props {
  open: boolean;
  onLeave: () => void;
  onClose: () => void;
}
export default function RfqLeaveDialog(props: Props) {
  const classes = RfqCommonDialogStyles();
  const { open, onClose, onLeave } = props;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className={classes.root}
      maxWidth="xs"
    >
      <Grid className={classes.header}>
        <CustomizedTypography variant="h4" fontWeight="700">
          견적요청 나가기
        </CustomizedTypography>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </Grid>
      <Grid className={classes.content}>
        <CustomizedTypography variant="h4" color="textPrimary">
          견적요청 페이지에서 나가시겠습니까?
        </CustomizedTypography>
        <CustomizedTypography
          variant="body1"
          color="textSecondary"
          gutterBottoms={46}
        >
          페이지에서 나가시면 작성한 견적요청 내용이 모두 삭제됩니다.
        </CustomizedTypography>
      </Grid>
      <Divider />
      <DialogActions className={classes.footer}>
        <CustomizedButton
          className={classes.confirmButton}
          color="error"
          onClick={onLeave}
        >
          나가기
        </CustomizedButton>
        <CustomizedButton
          className={classes.confirmButton}
          color="default"
          onClick={onClose}
        >
          취소
        </CustomizedButton>
      </DialogActions>
    </Dialog>
  );
}
